import { useTranslation } from 'react-i18next';

export type FilterType = 'all' | 'active' | 'interview' | 'closed';

const FILTERS: { value: FilterType; labelKey: string }[] = [
  { value: 'all', labelKey: 'dashboard.applications.filters.all' },
  { value: 'active', labelKey: 'dashboard.applications.filters.active' },
  { value: 'interview', labelKey: 'dashboard.applications.filters.interview' },
  { value: 'closed', labelKey: 'dashboard.applications.filters.closed' },
];

export function ApplicationFilters({
  activeFilter,
  onFilterChange,
}: {
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2 mb-5 overflow-x-auto pb-1 scrollbar-hide">
      {FILTERS.map(filter => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          className={`rounded-lg px-3.5 py-1.5 text-xs font-semibold whitespace-nowrap transition-colors ${
            activeFilter === filter.value
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-card text-cj-green-dark border border-border'
          }`}
        >
          {t(filter.labelKey)}
        </button>
      ))}
    </div>
  );
}
